import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import {ErrorType} from "~/enums/ErrorType";
import EmbeddedCollectionValidator from "~/models/navigableValidators/embeddedCollectionValidator";
import FormElement from "../../../formability/form_builder/models/formElements/formElement";
import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";

export default class FormSectionValidator<T> extends EmbeddedCollectionValidator<WorkflowStep> {
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType = ErrorType.mustBePresent;

  getAllChildren(model): Array<FormElement> {
    const formSection = this.getCollection(model);
    if (formSection) {
      return formSection.formElementsArrayDeep;
    } else return [];
  }
}